import { render } from "./ConfirmLayout.vue?vue&type=template&id=289d31d8"
import script from "./ConfirmLayout.vue?vue&type=script&lang=js"
export * from "./ConfirmLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__